/* src/app/components/master-detail-cdc-authorization/components/cdc-waiting/cdc-waiting.component.scss */
.waiting-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--yf-spacing3, 36px) var(--yf-spacing2, 24px);
}
.waiting-container .big-spinner {
  width: 44px;
  height: 44px;
}
.card-skeleton {
  width: 180px;
  aspect-ratio: 1.586;
  border-radius: var(--yf-border-radius, 12px);
  background:
    linear-gradient(
      135deg,
      var(--yf-secondary, #002945) 0%,
      var(--yf-primary, #297eb2) 100%);
  box-shadow: var(--yf-shadow, 5px 5px 10px rgba(0, 0, 0, 0.1215686275));
  position: relative;
  overflow: hidden;
  padding: 14px;
}
.card-skeleton .chip {
  width: 28px;
  height: 20px;
  border-radius: 4px;
  background:
    linear-gradient(
      135deg,
      #e8d48b,
      #c8a951);
}
.card-skeleton .line {
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.35);
  margin-top: 14px;
}
.card-skeleton .line.l1 {
  width: 80%;
}
.card-skeleton .line.l2 {
  width: 45%;
}
.card-skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      105deg,
      transparent 40%,
      rgba(255, 255, 255, 0.28) 50%,
      transparent 60%);
  animation: shimmer 1.6s infinite;
}
@keyframes shimmer {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
.title {
  margin: var(--yf-spacing2, 24px) 0 var(--yf-spacing1, 12px);
  font-weight: 600;
  color: var(--ion-color-secondary);
}
.steps {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 320px;
}
.steps li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 15px;
  color: var(--ion-color-secondary);
}
.steps li ion-icon {
  font-size: 22px;
  flex-shrink: 0;
}
.steps li ion-spinner {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
.steps li.pending {
  opacity: 0.45;
}
.steps li.active {
  font-weight: 600;
}
.hint {
  margin-top: var(--yf-spacing1, 12px);
  font-size: 13px;
  text-align: center;
  opacity: 0.7;
  max-width: 320px;
}
/*# sourceMappingURL=cdc-waiting.component.css.map */
